import { Service } from '@angular/core';
import type { Observable } from 'rxjs';
import type {
  StatisticsByType,
  StatisticsDataByType,
  StatisticsType,
} from '../enums/statistics-type';
import { ApiService } from './api.service';

@Service()
export class StatisticsService extends ApiService {
  public getStatistics<T extends StatisticsType>(
    type: T,
    params?: StatisticsDataByType[T],
  ): Observable<StatisticsByType[T]> {
    return this.get(
      `/statistics/${type}`,
      params ? { params: params as any } : undefined,
    );
  }
}
